import React from 'react';
import { Link } from 'react-router-dom';

export function EmergingTrendsCard({ trends }) {
  if (!trends || trends.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: 'var(--bg-primary)',
      border: '1px solid var(--border-color)',
      borderRadius: 12,
      padding: 24,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <div style={{
          width: 28, height: 28, borderRadius: 7,
          background: 'var(--coros-red-light)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14,
        }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--coros-red)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)' }}>
            Emerging Trends
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
            Low volume, high growth
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {trends.map((trend) => (
          <Link
            key={trend.id}
            to={`/clusters/${trend.id}`}
            style={{
              display: 'block',
              background: 'var(--bg-tertiary)',
              borderRadius: 8,
              padding: '12px 14px',
              border: '1px solid var(--border-light)',
              textDecoration: 'none',
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
            onMouseLeave={e => e.currentTarget.style.background = 'var(--bg-tertiary)'}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>
                {trend.name}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  {trend.ticket_count}
                </span>
                {trend.is_new ? (
                  <span style={{
                    fontSize: 10, fontWeight: 700, color: 'var(--coros-red)',
                    background: 'var(--coros-red-light)',
                    padding: '2px 7px', borderRadius: 99,
                    textTransform: 'uppercase', letterSpacing: '0.5px',
                  }}>
                    NEW
                  </span>
                ) : trend.growth_percentage !== null ? (
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-success)' }}>
                    +{trend.growth_percentage}%
                  </span>
                ) : null}
              </div>
            </div>

            {trend.sample_quote && (
              <p style={{
                fontSize: 12, color: 'var(--text-muted)',
                fontStyle: 'italic', margin: 0,
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                "{trend.sample_quote}"
              </p>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default EmergingTrendsCard;
